import { TFunction } from 'i18next';

export const PRODUCT_OPTIOINS_LIMIT = 10;
export const PRODUCT_OPTION_DISPLAY_LIMIT = 10;
export const SUB_OPTIONS_LIMIT = 10;

export const ActiveStatusOptions = (t: TFunction) => [
  { label: t('Active'), value: '1' },
  { label: t('Inactive'), value: '0' },
];
export const SelectionMethodOptions = (t: TFunction) => [
  { label: t('Single Choice'), value: '1' },
  { label: t('Multiple Choice'), value: '2' },
];
export const RequirementOptions = (t: TFunction) => [
  { label: t('Opt_Required'), value: '1' },
  { label: t('Opt_Optional'), value: '0' },
];
export const ProductOptionTableColumnWidth = {
  drag: '10%',
  name: '15%',
  product_sub_options_name: '20%',
  product_sub_options_extra_price: '15%',
  forced_type: '15%',
  option_type: '15%',
  action: '10%',
};

export const ProductOptionButtonIconSize = '20px';
export const ProductOptionActionButtons = {
  button: {
    width: '30px',
    height: '30px',
  },
  icon: '20px',
};
